import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import {Box, Button, Container, Paper, TextField, Typography, useMediaQuery, useTheme} from "@mui/material";
import { useUserContext} from "../user-context";
import authService from "../../api/authService";
import { syncDayjsGlobalLocale } from "../../i18n/muiAdmin";
import { t } from "../../i18n/t";

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const {setUser} = useUserContext();
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        syncDayjsGlobalLocale();
    }, []);

    const handleSubmit = async (e: { key?: any; target?: any; preventDefault: () => void }) => {
        e.preventDefault();
        try {
            const response = await authService.login({ email, password })
            setUser(response?.data?.access_token)
            localStorage.setItem('access_token', response?.data?.access_token);
            const ctx = await authService.getAccessContext();
            if (ctx?.data?.isAdmin || ctx?.data?.hasSubordinates) {
                navigate('/dashboard/users');
            } else {
                navigate('/dashboard');
            }

        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    const handleKeyDown = (event: { key?: any; target?: any; preventDefault: () => void; }) => {
        if (event.key === 'Enter') {
            const form = event.target.form;
            const isValid = form.checkValidity();
            if (isValid) {
                handleSubmit(event).catch(()=>{});
            }
        }
    };
    return (
        <div style={{backgroundImage: "url('img.png')"}}>
            <Container
                maxWidth="sm"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    marginLeft:isMobile?0:5
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        padding: 4,
                        borderRadius: 2,
                        width: '100%',
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h1"
                        gutterBottom
                        textAlign="center"
                    >
                        {t('login.title')}
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                        }}
                    >
                        <TextField
                            label="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            variant="outlined"
                            fullWidth
                            required
                        />
                        <TextField
                            label={t('login.password')}
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            variant="outlined"
                            fullWidth
                            required
                            onKeyDown={handleKeyDown}
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            size="large"
                        >
                            {t('login.submit')}
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </div>
    );
};

export default Login;
